"use client";

import { CarevincoMark } from "@/shared/components/CarevincoLogo";

type ProgressLoaderContentProps = {
  compact?: boolean;
  message?: string;
  title?: string;
};

type SectionProgressBarProps = ProgressLoaderContentProps & {
  className?: string;
  visible: boolean;
};

export function ProgressLoaderContent({
  compact = false,
  message = "Preparing your care workspace...",
  title = "Loading Carevinco",
}: ProgressLoaderContentProps) {
  return (
    <div className={`care-progress-content${compact ? " care-progress-content--compact" : ""}`}>
      <div aria-hidden="true" className="care-progress-brandmark">
        <CarevincoMark size={compact ? 36 : 50} />
      </div>
      <i aria-hidden="true" className="care-progress-diamond" />
      <div className="care-progress-copy">
        <strong>{title}</strong>
        {message ? <p>{message}</p> : null}
      </div>
      <div aria-hidden="true" className="care-progress-rail">
        <span className="care-progress-rail__fill" />
        <span className="care-progress-rail__glow" />
      </div>
    </div>
  );
}

export function SectionProgressBar({
  className = "",
  message,
  title = "Loading Carevinco",
  visible,
}: SectionProgressBarProps) {
  if (!visible) {
    return null;
  }

  return (
    <div
      aria-busy="true"
      aria-live="polite"
      className={`care-section-progress ${className}`.trim()}
      role="status"
    >
      <ProgressLoaderContent compact message={message} title={title} />
    </div>
  );
}
